import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { isValid } from 'date-fns';
import { SelectItem } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class FormService {

  constructor() { }

  markPristine(form: FormGroup): void {
    Object.keys(form.controls).forEach(control => {
      form.controls[control].markAsPristine();
    });
  }

  parseBoolToStr(obj: any) {
    let ret: any = {};
    for (const key in obj) {
      if (typeof obj[key] === "boolean") {
        ret[key] = obj[key] ? 'S' : 'N';
      }
    }
    return ret;
  }

  applyFilter(formGroup: FormGroup, filters: any, uniqueDateFields?: string[], excludes?: string[]) {
    if (this.isEmpty(formGroup, excludes)) {
      const patchValue = this.parseFilter(filters, uniqueDateFields);
      formGroup.patchValue(patchValue, { emitEvent: false });
    }
  }

  parseFilter(filter: any, uniqueDateFields: string[] = []) {
    let obj: any = {};
    for(const key in filter) {
      obj[key] = filter[key].value;

      
      if (this.isValidDateArray(filter[key].value)) {
        let data_1 = new Date(filter[key].value[0]).toISOString().split('T')[0];
        let data_2 = new Date(filter[key].value[1]).toISOString().split('T')[0];

        if (uniqueDateFields.includes(key)) {
          obj[key] = data_1;
        } else {
          obj['data_inicial'] = data_1;
          obj['data_final'] = data_2;
        }
      }
    }

    return obj;
  }

  isValidDateArray(arr: any[]): boolean {
    if (Array.isArray(arr) && arr.length === 2) {
      const date1IsValid = isValid(new Date(arr[0]));
      const date2IsValid = isValid(new Date(arr[1]));

      return date1IsValid && date2IsValid;
    }

    return false;
  }

  parseStrToBool(obj: any) {
    let ret: any = {};
    for (const key in obj) {
      if (typeof obj[key] === "string" && (obj[key] === "S" || obj[key] === "N")) {
        ret[key] = obj[key] === 'S' ? true : false;
      }
    }
    return ret;
  }

  parseArrayToString(data: any[]) {
    data = data?.filter((value) => !!value);
    return data?.join(',') ?? undefined;
  }

  parseStringToArray(data: string | null | undefined): Array<string | number> | undefined {
    const stringArray = data?.split(',') ?? undefined;
    if (stringArray) {
      const array: Array<string | number> = stringArray.map((value) => {
        const parsedValue = parseInt(value.trim(), 10);
        return isNaN(parsedValue) ? value : parsedValue;
      });
      return array;
    }
    return undefined;
  }

  getDirtyValues(cg: FormGroup, preserve = ['id', 'nanoid']): { changes: any, isChanged: boolean } {
    const dirtyValues: any = {};
    let changed = false;
    Object.keys(cg.controls).forEach(c => {
      const currentControl: any = cg.get(c);

      if (currentControl?.dirty || preserve.indexOf(c) !== -1) {
        dirtyValues[c] = currentControl.value;
        changed = preserve.indexOf(c) === -1 ? true : false;
      }
    });
    return {
      changes: dirtyValues,
      isChanged: changed
    };
  }

  toSelectItem(obj: any, { label, value, noSelect }: { label: string, value: string, noSelect?: string }): SelectItem[] {

    const items = obj.map((el: any) => ({ label: el[label], value: el[value] }));

    return [(noSelect ? { label: noSelect, value: null } : {} as any), ...items];
  }

 isEmpty(form: FormGroup, exclude?: string[]) {
    return !Object.keys(form.value).some(k => {
      if (exclude && exclude.includes(k)) {
        return false;
      }
      return !!form.value[k];
    });
  }

  dinamicFilter(array: any[], filters: string[], value: string) {
    const filtered = array.filter((el: any) => {
        const hasFilter = (obj: any, path: string) => {
            const parts = path.split('.');
            let value = obj;
            for (const part of parts) {
                if (!value || !value[part]) {
                    return false;
                }
                value = value[part];
            }
            return true;
        };

        return filters.some(filter => {
            if (hasFilter(el, filter)) {
                const parts = filter.split('.');
                const filterValue = parts.reduce((acc, part) => acc[part], el).toLowerCase();
                return filterValue.includes(value.toLowerCase());
            } else {
                return false;
            }
        });
    });

    return filtered;
  }

  sort(arr: SelectItem[]) {
    return arr.sort((a: SelectItem, b: SelectItem) => {
      const labelA = a.label?.toUpperCase() || '';
      const labelB = b.label?.toUpperCase() || '';
  
      if (labelA < labelB) {
        return -1;
      }
      if (labelA > labelB) {
        return 1;
      }
  
      return 0;
    });
  }

  createFilterDate(formGroup?: FormGroup | null, date?: string) {
    let filter: string[] | null = null;

    if (date) {
      filter = [`${date}T00:00:00Z`, `${date}T23:59:59Z`];
    } else if (formGroup) {
      let { data_inicial, data_final } = formGroup.value;
      filter =
        data_inicial && data_final
          ? [`${data_inicial}T00:00:00Z`, `${data_final}T23:59:59Z`]
          : data_inicial
          ? [`${data_inicial}T00:00:00Z`, `${data_inicial}T23:59:59Z`]
          : null;
    }
    return filter;
  }
}
